<div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
  <div class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
  </div>
  <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
    <div class="flex flex-row justify-start items-center">
      <button mat-button class="save-changes m-r-10" (click)="save()"
              particleAnalytics
              analyticsCategory="Save"
              analyticsAction="Save"
              [disabled]="this.editedFields.length==0">
        <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
      </button>
    </div>
  </div>
</div>
<mat-sidenav-container>
  <!-- CENTER -->
  <div class="center full-grow-no-shrink-no-basis">
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg full-grow-no-shrink-no-basis">
      <!-- CONTENT TOOLBAR -->
      <div [ngClass]="containerClass" class="flex flex-col full-grow-no-shrink-no-basis">
        <particle-dynamic-form-container class="particle-dynamic-form-container" *ngIf="formField && item"
                                         [formField]="formField"
                                         [fieldConfig]="fieldConfig"
                                         [sourceType]="sourceType"
                                         [endpointName]="endpointName"
                                         [item]="item"
                                         [showDelete]="showDelete"
                                         [invalidateSubject]="invalidateSubject"
                                         [showLanguageOption]="showLanguageOption"
                                         [editedFields]="editedFields"
                                         (valueChanged)="onValueChanged($event)"
        >
        </particle-dynamic-form-container>
      </div>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</mat-sidenav-container>
